import { useState } from "react";

import { InvestmentProposalPreferredContactSchedulesRequest } from "@/api/generated";
import { PropallyApiFactory } from "@/module/CustomApiFactory";

// 希望連絡日程の送信先。投資提案 / ユーザーオファー / 査定提案でエンドポイントだけが異なり、
// リクエストボディ（InvestmentProposalPreferredContactSchedulesRequest）は 3 者共通なので
// 呼び出し側が種別を渡すだけで済むよう 1 つのフックにまとめている
export type PreferredContactSchedulesProposalType = "investment" | "user_offer" | "assessment";

interface UseUpdatePreferredContactSchedules {
  updatePreferredContactSchedules: (
    proposalType: PreferredContactSchedulesProposalType,
    id: number,
    request: InvestmentProposalPreferredContactSchedulesRequest
  ) => Promise<boolean>;
  loading: boolean;
  error: string;
}

export const useUpdatePreferredContactSchedules = (): UseUpdatePreferredContactSchedules => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fp = PropallyApiFactory();

  const updatePreferredContactSchedules = async (
    proposalType: PreferredContactSchedulesProposalType,
    id: number,
    request: InvestmentProposalPreferredContactSchedulesRequest
  ): Promise<boolean> => {
    setLoading(true);
    setError("");

    try {
      const options = { withCredentials: true };
      const res =
        proposalType === "user_offer"
          ? await fp.v1UserProposalsUserProposalIdPreferredContactSchedulesPatch(id, request, options)
          : proposalType === "assessment"
          ? await fp.v1AssessmentProposalsAssessmentProposalIdPreferredContactSchedulesPatch(id, request, options)
          : await fp.v1InvestmentProposalsInvestmentProposalIdPreferredContactSchedulesPatch(id, request, options);
      return res.status === 200;
    } catch (e: unknown) {
      // Sentry へは CustomApiFactory の interceptor が既に送っているため、
      // CaptureConsole(levels: error) で二重計上しないよう console.error は出さない
      setError(e instanceof Error ? e.message : "不明なエラー");
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { updatePreferredContactSchedules, loading, error };
};
